<template>
	<div class="business_and_technology">
		<PageHeader
			:image="require('../assets/business_and_technology/title.svg')"
			:imageSp="require('../assets/business_and_technology/title.svg')"
			alt="business and technology"
			headCatch="エンタープライズ、<br class='over_display'>
          AI・データサイエンス、組込み領域。<br class='over_display'>
          誰も解決したことのない課題に、<br class='over_display'>
          磨き込まれた技術力で挑む。"
			intro="豆蔵の代表的な3つの事業領域は、<br class='over_display'>
        「エンタープライズ領域」「AI・データサイエンス領域」「組込み領域」。<br>
        それぞれの領域において、情報化やIoTシステムの最適化を提供しています。<br>
        課題発見から企画・デザイン・開発・運用を含む、<br class='over_display'>
        システム／ソフトウェアのスタイル変革まで幅広く提供できる、<br class='over_display'>
        先進のITコンサルティングファームです。<br>
        ここでは、3つの領域のそれぞれの強みと、<br class='over_display'>
        プロジェクトの実例や、大学との連携事例を紹介します。"
		/>
		<BusinessArticle />
	</div>
</template>

<script>
// @ is an alias to /src
import PageHeader from '@/components/mainpage/PageHeader.vue';
import BusinessArticle from '@/components/mainpage/BusinessArticle.vue';
export default {
	name: 'business_and_technology',
	components: {
		PageHeader,
		BusinessArticle,
	},
};
</script>

<style lang="scss" scoped>
.business_and_technology {
	position: relative;
	overflow: hidden;
	width: 100%;
}
</style>
